'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiImprint = function ApiImprint($http, GenericMethods) {
	_classCallCheck(this, ApiImprint);

	return {
		//returns the details to be displayed on imprint page
		getImprintDetails: function getImprintDetails() {
			return GenericMethods.retrieveLocalFile('data/', 'imprintDetails.json');
		}
	};
};

ApiImprint.inject = ['$http'];

exports.default = ApiImprint;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiImprint.js
 **/